import { z } from 'zod';
import type { TFunction } from 'i18next';

const editCryptoAddressFormSchema = (t: TFunction) => {
  const required = t('savedAddresses.cryptoAddress.validation.required');

  return z.object({
    networkName: z.string().nonempty({ message: required }),
    cryptoAddress: z.string().nonempty({ message: required }),
    templateName: z.string().nonempty({ message: required }),
  });
};

export { editCryptoAddressFormSchema };
